import React, { Component } from 'react';
import { array, string, bool } from 'prop-types';
import ProductPickerIcon from './product-picker-icon/ProductPickerIcon';
import ProductPickerInfo from './product-picker-info/ProductPickerInfo';
import './ProductPicker.css';

export default class ProductPicker extends Component {
  static propTypes = {
    products: array.isRequired,
    type: string,
    isFee: bool,
  };

  static defaultProps = {
    type: '',
    isFee: false,
  };

  state = {
    activeProduct: {},
  };

  componentDidMount() {
    const { products } = this.props;
    if (products.length > 0) {
      this.handleActivate(products);
    }
  }

  setActiveProduct = (product) => {
    this.setState({ activeProduct: product });
  }

  handleActivate = (products) => {
    const recommendedProduct = products.find(product => product.recommended);
    this.setState({ activeProduct: recommendedProduct || products[0] });
  }

  render() {
    const {
      products, type, isFee,
    } = this.props;
    return (
      <div className="product-picker">
        <div className="product-picker-icons">
          {products.map(product => (
            <ProductPickerIcon
              key={product.type}
              product={product}
              active={this.state.activeProduct.type === product.type}
              onClickIcon={this.setActiveProduct}
            />
          ))}
        </div>
        <ProductPickerInfo
          product={this.state.activeProduct}
          type={type}
          isFee={isFee}
        />
      </div>
    );
  }
}
